import React from 'react';
import PropTypes from 'prop-types';
import { MemoryMapSlide } from '../MemoryMapSlide';
import { ChapterPickSlide } from '../ChapterPickSlide';
import { FirstQuestionSlide } from '../FirstQuestionSlide';
import { TalkSlide } from '../TalkSlide';
import { MemoryBookSlide } from '../MemoryBookSlide';

const RESULT_VARIANTS = {
    map: MemoryMapSlide,
    chapter: ChapterPickSlide,
    firstQuestion: FirstQuestionSlide,
    talk: TalkSlide,
    book: MemoryBookSlide
};

/* The slides after the email: the Memory Map and the steps that lead to the paywall */
function ResultSlideV3({ variant, ...slideProps }) {
    const Variant = RESULT_VARIANTS[variant];

    return <Variant {...slideProps} />;
}

ResultSlideV3.propTypes = {
    variant: PropTypes.oneOf(Object.keys(RESULT_VARIANTS)).isRequired
};

export {
    ResultSlideV3
};
